export default __webpack_public_path__ + "static/media/Ethos.573b83bc.jpg";